var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.show)?_c('div',{staticClass:"home"},[_c('video',{attrs:{"autoplay":"","loop":"","src":require("../assets/video3.webm")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }